// Kept apart from CreatePage so pages that only need a limit don't pull in the
// create form and the platform inputs it renders.

/** Longest microreel title, as on the platform's New microreel page. */
export const TITLE_MAX = 40;
